import { ApiConfig, HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE } from '@skylab-shared/utils';
import { ReportPrintQuery, ReportPrintQueryParameters, ReportPrintResult } from '../queries/report-print.query-base';

export interface SalesWstoPrintingResult extends ReportPrintResult { }

export interface SalesWstoPrintingParameters extends ReportPrintQueryParameters { }

export class SalesWstoPrintingQuery extends ReportPrintQuery<SalesWstoPrintingResult> {
    public constructor(parameters: SalesWstoPrintingParameters) {
        super(parameters);
    }
}

export class SalesWstoPrintingQueryHandlerBase implements QueryHandler<SalesWstoPrintingQuery, SalesWstoPrintingResult> {
    private static Url = TaggedUrl.join('salesWsto/printing', [Tags.Api]);

    public constructor(private readonly http: HttpService) {  }

    public async handleAsync({ parameters }: SalesWstoPrintingQuery): Promise<SalesWstoPrintingResult> {
        const requestData = {
            compress: parameters.compress,
            password: parameters.password,
            ecoMode: parameters.ecoMode,
            landscape: parameters.landscape,
            config: {
                parameters: JSON.stringify(parameters.parameters),
                columns: parameters.columns,
                summary: parameters.summary,
                report: 'SprzedazWsto'
            }
        };

        const { data } = await this.http.post<{ url: string; }>(SalesWstoPrintingQueryHandlerBase.Url, requestData, {timeout: 3 * MS_PER_MINUTE });
        return {
            url: `${ApiConfig.baseUrl}${data.url}`
        };
    }
}
